import { TreeNodeFragment } from "@/Common/fragments/GenericTree";
import { apiInstance, gql } from "@/services/httpAdapter";
import { EligibilityFragment } from "../spiffs/fragments";

export async function getSpiffAwardsTree({ locationId, department }: Record<string, string>) {
	const query = gql`
		query getSpiffAwardsTree($locationId: String!, $department: String!) {
			getSpiffAwardsTree(locationId: $locationId, department: $department) {
				locationId
				department
				tree {
					...TreeNode
					list {
						...TreeNode
						list {
							...TreeNode
							list {
								...TreeNode
							}
						}
					}
				}
				hints {
					defaultSelectedIds
					expandedIds
					prefetchIds
				}
			}
		}

		${TreeNodeFragment}
	`;

	const variables = {
		locationId,
		department,
	};

	const response = await apiInstance.post("/graphql", { query, variables });
	return response?.data?.data?.getSpiffAwardsTree;
}

export async function getSpiffAwards({ locationId, spiffItemId, department, commissionCycleId, recipient }: Record<string, string>) {
	const filter = { spiffItem: spiffItemId, commissionCycleId, recipient };
	switch (department.toLowerCase()) {
		case "sales":
			return getSalesSpiffAwards({ locationId, filter });
		case "service":
			return getServiceSpiffAwards({ locationId, filter });
		default:
			return null;
	}
}

export async function getSalesSpiffAwards({ locationId, filter }: Record<string, any>) {
	const query = gql`
		query getSalesSpiffAwards($locationId: String!, $filter: SpiffAwardsFilterInput) {
			getSalesSpiffAwards(locationId: $locationId, filter: $filter) {
				_id
				locationId
				commissionCycleId
				payPeriodId
				recipient {
					_id
					fullName
				}
				spiffSetup {
					_id
					title
				}
				spiffItem {
					_id
					spiffType
					reward
					effectiveDateRangeFrom
					effectiveDateRangeTo
					title
					eligibility {
						...EligibilityFields
					}
					requiredDealStatus
					createdBy {
						_id
						fullName
					}
				}
				awards {
					_id
					spiffEntry
					spiffDate
					spiffType
					deals {
						stockNumber
						dealNumber
					}
					reward
					createdAt
					updatedAt
				}
				createdAt
				updatedAt
			}
		}
		${EligibilityFragment}
	`;

	const variables = {
		locationId,
		filter,
	};

	const response = await apiInstance.post("/graphql", { query, variables });
	return response?.data?.data?.getSalesSpiffAwards;
}

export async function getServiceSpiffAwards({ locationId, filter }: Record<string, any>) {
	const query = gql`
		query getServiceSpiffAwards($locationId: String!, $filter: SpiffAwardsFilterInput) {
			getServiceSpiffAwards(locationId: $locationId, filter: $filter) {
				_id
				locationId
				commissionCycleId
				payPeriodId
				recipient {
					_id
					fullName
				}
				spiffSetup {
					_id
					title
				}
				spiffItem {
					_id
					spiffType
					reward
					type
					title
					description
					effectiveDateRangeFrom
					effectiveDateRangeTo
					eligibilityDays
					transactionType
					eligibility {
						...EligibilityFields
					}
					createdBy {
						_id
						fullName
					}
				}
				awards {
					_id
					spiffEntry
					spiffDate
					spiffType
					repairOrders {
						vinNumber
						repairOrderNumber
					}
					reward
					updatedAt
					createdAt
				}
				createdAt
				updatedAt
			}
		}
		${EligibilityFragment}
	`;

	const variables = {
		locationId,
		filter,
	};

	const response = await apiInstance.post("/graphql", { query, variables });
	return response?.data?.data?.getServiceSpiffAwards;
}
